export const DATE_FORMATS = [
  // Month-name based formats
  "D/MMM/YYYY",
  "D-MMM-YYYY",
  "MMM-D-YYYY",
  "MMM/D/YYYY",
  "D MMM YYYY",
  "MMM D YYYY",
  "YYYY-MMM-D",
  "YYYY/MMM/D",
  "YYYY MMM D",
  "D MMM, YYYY",
  "MMM D, YYYY",
  "D-MMMM-YYYY",
  "MMMM D YYYY",
  "D MMMM YYYY",
  "MMMM-D-YYYY",
  "YYYY-MMMM-D",

  // Numeric formats
  "D/M/YYYY",
  "DD/MM/YYYY",
  "D-MM-YYYY",
  "DD-MM-YYYY",
  "YYYY/MM/DD",
  "YYYY-MM-DD",
  "M/D/YYYY",
  "MM-DD-YYYY",
  "MM/DD/YYYY",
];
